import React, { useCallback, useContext, useRef } from 'react'
import { ParentContext } from '../ParentContext';
import { UiItemContext } from '../UiItemContext';
import { CurrentSettingsContext } from '../SettingsDataContext';
import { PapsContext } from '../PapsContext';
import { PageAreaContext } from '../PageAreaContext';
import { currentHelpers } from 'global/redirection/current';
import { _showAppLogs } from '../LogContext';

export const usePageItemInfo = () => {

  const currentSettingsContext = useContext(CurrentSettingsContext)
  const { currentSettings_state } = currentSettingsContext ?? {}

  const papsContext = useContext(PapsContext)
  const { paps_state } = papsContext ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { page_state } = states ?? {}

  const pageAreaContext = useContext(PageAreaContext)
  const { pageArea_state } = pageAreaContext ?? {}

  const uiItemContext = useContext(UiItemContext)
  const { item_state } = uiItemContext ?? {}

  // Always holds the latest values
  const infoRef = useRef({
    currentSettings_state,
    item_state,
    pageArea_state,
    page_state,
    paps_state,
  })

  // Update the ref on every render
  infoRef.current = {
    currentSettings_state,
    item_state,
    pageArea_state,
    page_state,
    paps_state,
  }

  const getPageItemInfo = useCallback(({ uivi }) => {
    const {
      page_state,
      paps_state
    } = infoRef.current

    const { pathViews, pathName, view, viewKey, otherView, pageKey, landingView } = paps_state ?? {}
    let trueView = (viewKey || otherView) ? view : view + '_list'
    trueView = currentHelpers.getTrueView(pathViews, view, trueView, landingView, viewKey)

    const { aps_page } = _.get(page_state, 'pageSettings', {});
    const { viewItems } = aps_page;
    const _pageItem = viewItems?.[uivi] || {}
    if (_pageItem.propSections) {
      _.forEach(_pageItem.propSections, (ps, psKey) => {
        ps.key = psKey
      })
    }
    _pageItem.key = uivi
    if (_showAppLogs.pageInfo) {
      console.group('🛡️🛡️ getPageItemInfo', uivi)
      console.log('_pageItem', _pageItem)
      console.groupEnd()
    }
    return { pageItemInfo: _pageItem || {}, _pathName: pathName }
  }, []);

  return { getPageItemInfo }

}
